import React,{useEffect,useState,useRef} from 'react'
import styled from 'styled-components';
import { Button } from './Button';


const Container = styled.section`
  position:relative;
  height:100vh;
  width:100vw;
  overflow:hidden;
  
`
const HeroWrapper = styled.div`
  position:relative;
  display:flex;
  height:100%;
  width:100%;
  justify-content:center;
  align-items:center;
  overflow:hidden;
`
const HeroImage = styled.img`
  height:100vh;
  width:100vw;
  position:absolute;
  top:0;
  right:0;
  object-fit:cover;
`
const HeroSlide = styled.div`
  z-index:1;
  height:100%;
  width:100%
`
const HeroSlider = styled.div`
position:absolute;
  height:100%;
  width:100%;
  display:flex;
  justify-content:center;
  align-items:center;
  top:0;
  left:0;
`
const HeroContent = styled.div`
  position: absolute;
  color:#000;
  display:flex;
  flex-direction:column;
  justify-content:flex-start;
  color:#926F34;
  z-index:10;
  left:4rem;
  p{
    font-size:30px;
  }

`




const Hero = ({slides}) => {
  const [current, setCurrent] = useState(0);
  const timeout = useRef(null);
  const length = slides.length;
  useEffect(
    () => {
      const nextSlide = () => {
        setCurrent(current => (current === length - 1 ? 0 : current + 1));
      };
      timeout.current = setTimeout(nextSlide, 3000);
      return () => {
        if (timeout.current) {
          clearTimeout(timeout.current)
        }
      }
    },
    [current, timeout]
  )
  return (
    <Container>
      <HeroWrapper>
        {slides.map((slide, index) => {
          return (
            <HeroSlide key={index}>
              {index===current &&(
                <HeroSlider>
                <HeroImage src={slide.image} />
                <HeroContent>
                  <h1>{slide.title}</h1>
                    <Button href={slide.path} primary='true' big='true'>
                    {slide.label}
                  </Button>
                </HeroContent>
              </HeroSlider>
              )}
            </HeroSlide>
          )
        })}
      </HeroWrapper>
    </Container>
  )
}

export default Hero
